/* Elysian Roaster's Choice rotator (2026-09-30). Loaded (defer) by sections/elysian-plans.liquid only. Each [data-ely-rotator] cycles
   its frames: hold 1s, crossfade 0.6s, loop. It runs only while all of these hold: the rotator is the bag being shown (data-on, set by
   Liquid or by the coffee-choice swap in assets/elysian-subs-r2.js), it is on screen (IntersectionObserver), the tab is visible, and
   the visitor has not asked for reduced motion. Otherwise it pauses where it is. No controls, nothing focusable. */
(function () {
  var HOLD = 1000, FADE = 600;
  var reduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;

  function bind(el) {
    if (el.hasAttribute('data-ely-rotator-bound')) return;
    el.setAttribute('data-ely-rotator-bound', '');
    var frames = Array.prototype.slice.call(el.querySelectorAll('.ely-rotator__frame'));
    if (frames.length < 2) return;
    var i = 0, timer = null, seen = false;
    frames.forEach(function (f, n) { if (f.hasAttribute('data-on')) i = n; });

    function live() {
      return seen && el.hasAttribute('data-on') && !document.hidden && !(reduce && reduce.matches);
    }
    function step() {
      timer = null;
      if (!live()) return;
      var cur = frames[i];
      i = (i + 1) % frames.length;
      var next = frames[i];
      frames.forEach(function (f) { f.removeAttribute('data-prev'); });
      cur.removeAttribute('data-on'); cur.setAttribute('data-prev', '');
      next.setAttribute('data-on', '');
      timer = setTimeout(step, HOLD + FADE);
    }
    function sync() {
      if (live()) { if (!timer) timer = setTimeout(step, HOLD); }
      else if (timer) { clearTimeout(timer); timer = null; }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        seen = entries[entries.length - 1].isIntersecting; sync();
      }).observe(el);
    } else { seen = true; }
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['data-on'] });
    }
    document.addEventListener('visibilitychange', sync);
    if (reduce) {
      if (reduce.addEventListener) reduce.addEventListener('change', sync);
      else if (reduce.addListener) reduce.addListener(sync);
    }
    sync();
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-ely-rotator]'), bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
